export default {
  isRefreshed: false,
};
